import { useState } from "react";
import { useTranslation } from "react-i18next";
import PolicyAndPrivacyComponent from "src/components/user/policy-and-privacy-compontnent";
import SchoolRegisterFormStep1Component from "src/components/user/school-register-form-step1-component";
import SchoolRegisterFormStep2Component from "src/components/user/school-register-form-step2-component";
import QuestionsSchoolLeaderContainer from "../questions-school-leader-container/questions-school-leader-container";

function SchoolRegisterContainer() {
  const { t } = useTranslation();
  const [showStepForm, setShowStepForm] = useState<number>(0);

  return (
    <>
      {showStepForm === 2 ? (
        <QuestionsSchoolLeaderContainer />
      ) : (
        <div className="flex flex-col gap-8 items-center justify-center z-40 relative pt-[107px] pb-11 mobile:mx-6">
          <p className="font-arMedium text-black344 text-2xl mobile:text-xl">
            {t("registerForm.component.createAccountSchool")}
          </p>
          {showStepForm === 0 ? (
            <SchoolRegisterFormStep1Component
              passValue={showStepForm}
              setPassedValue={setShowStepForm}
            />
          ) : (
            <SchoolRegisterFormStep2Component
              passValue={showStepForm}
              setPassedValue={setShowStepForm}
            />
          )}
          <PolicyAndPrivacyComponent />
        </div>
      )}
    </>
  );
}

export default SchoolRegisterContainer;
